import { Button, Form, Input, message, Spin } from "antd";
import { useState } from "react";
import './auth.css';
import { useDispatch } from "react-redux";
import { serverFetch } from "@server";
import { userLoaded } from "@redux/actions";
import { showError } from "@extensions/utils";
import EnterCode from "@controls/enter-code/enter-code";

const Auth = () => {
  const d = useDispatch();
  const [form] = Form.useForm();
  const [data, setData] = useState({email: '', checkcode: '', name: ''});
  const [sentCode, setSentCode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [codeId, setCodeId] = useState();
  const [register, setRegister] = useState(false);

  const onSendCode = () => {
    if (!data.email) {
      message.error('Укажите email');
      return;
    }
    if (register && !data.name) {
      message.error('Укажите название фирмы');
      return;
    }
    setLoading(true);
    serverFetch(`auth/GenerateCheckcode?email=${encodeURIComponent(data.email)}&register=${register}&name=${encodeURIComponent(data.name ?? '')}`)
      .then((res) => {
        setSentCode(true);
        setLoading(false);
        setCodeId(res);
        message.info('Код отправлен');
      })
      .catch(e => {
        showError(e);
        setLoading(false);
      });
  }
  const onChangeValue = (value) => {
    setData({...data, ...value});
  }
  const onLogin = (loginData) => {
    setLoading(true);
    serverFetch('auth/Login', {method: 'POST', bodyData: loginData})
      .then(session => d(userLoaded(session)))
      .catch(e => {
        showError(e);
        setLoading(false);
      });
  }
  const onEnterCode = (checkcode) => {
    const newData = {...data, checkcode, id: codeId};
    setData(newData);
    onLogin(newData);
  }
  const switchMode = (nextRegister) => {
    setRegister(nextRegister);
    setSentCode(false);
  }

  return (
    <div className="auth-body">
      <div className="auth-panel">
        <div className="auth-brand">
          <img className="auth-brand-icon" src={`${process.env.PUBLIC_URL}/botva-tasks-icon.svg`} alt="Botva Tasks" />
          <div className="auth-brand-name">BOTVA TASKS</div>
        </div>

        <Spin spinning={loading}>
          <div className="auth-form">
            <div className="auth-form-title">{register ? "РЕГИСТРАЦИЯ" : "ВХОД"}</div>
            <Form form={form} onFinish={onSendCode}>
              {register && (
                <Form.Item name="name">
                  <Input
                    placeholder="Название фирмы"
                    disabled={loading || sentCode}
                    onChange={(e) => onChangeValue({name: e.target.value})}
                  />
                </Form.Item>
              )}
              <Form.Item name="email">
                <Input
                  placeholder="your@email.com"
                  disabled={loading || sentCode}
                  onChange={(e) => onChangeValue({email: e.target.value})}
                />
              </Form.Item>
              {!sentCode && (
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    className="auth-form-btn"
                  >
                    Отправить код
                  </Button>
                </Form.Item>
              )}
              {!loading && sentCode && (
                <>
                  <div className="auth-enter-code-title">ВВЕДИТЕ КОД</div>
                  <Form.Item>
                    <EnterCode len={6} onFinish={onEnterCode} />
                  </Form.Item>
                </>
              )}
            </Form>
          </div>
        </Spin>

        {register ? (
          <div className="auth-create">
            Есть учетная запись?
            <div className="auth-create-link" onClick={() => switchMode(false)}>Войти</div>
          </div>
        ) : (
          <div className="auth-create">
            Нет учетной записи?
            <div className="auth-create-link" onClick={() => switchMode(true)}>Создать</div>
          </div>
        )}
        <div className="auth-legal">Botva Tasks</div>
      </div>
    </div>
  )
}

export default Auth;
